import { MasterData, MasterDataItem } from 'api/master/master-data.api';

export let _masterDataStored = {
  district: [],
  language: [],
  level: [],
  position: [],
  province: [],
  skill: [],
  status: [],
  contract: [],
  status_cv: [],
  partner: [],
  rank_company: [],
  status_cv1: [],
  group_document: [],
  candidate_type: [],
  bank_acc: [],
  accounting: [],
  block: [],
  legal: [],
  flag: [],
  content: [],
  zalo: [],
  email: [],
  rate_kpi_rec: [],
  rate_kpi_sale: [],
  kpi_index: [],
  phone : [],
  linkedin : [],
  facebook : [],
  combo_uv : [],
  rate_am : [],
  certificates : [],
  rank_job: [],
};

export type MasterDataKeys = keyof typeof _masterDataStored;

type MasterDataRes<V> = V extends number ? MasterDataItem : MasterDataItem[];

export function masterData<K extends MasterDataKeys, V extends number | Array<number> | unknown>(
  key: K,
  value?: V
): MasterDataRes<V> {
  const masterData: MasterDataItem[] = _masterDataStored[key] || [];

  if (value) {
    if (typeof value === 'number') return (masterData.find((item) => item.value === value) || {}) as MasterDataRes<V>;

    return masterData.filter((item) => (value as Array<number>).includes(item.value)) as MasterDataRes<V>;
  }

  return masterData as MasterDataRes<V>;
}

export function setMasterData(masterDataStored: MasterData) {
  _masterDataStored = masterDataStored as any;
}
